import { render } from "./LoaderContinue.vue?vue&type=template&id=2afebd00"
import script from "./LoaderContinue.vue?vue&type=script&lang=js"
export * from "./LoaderContinue.vue?vue&type=script&lang=js"

import "./LoaderContinue.vue?vue&type=style&index=0&id=2afebd00&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__